module.exports = __webpack_public_path__ + "img/o.871ac659.jpg";